import type { Subscriptions } from '@ps/models/lib/creator-subscription';
import {
  PopStoreSubscriptionLevel,
  PopStoreSubscriptionStatus,
} from '@ps/models/lib/creator-subscription';

/**
 * Upper price bound for a tier (in dollars), or `undefined` when
 * no upper bound applies. 1:1 with legacy
 * `getMaximumSubscriptionPrice`.
 *
 * If FAN is active, SUBSCRIBER's max is `FAN - 10¢`.
 * If VIP is active, FAN's max is `VIP - 10¢`.
 * VIP has no upper bound.
 */
export function getMaximumSubscriptionPrice(
  subscriptions: Subscriptions,
  level: PopStoreSubscriptionLevel,
): number | undefined {
  const getPrice = (subscriptionLevel: PopStoreSubscriptionLevel): number => {
    const subscription = subscriptions?.[subscriptionLevel];
    return subscription &&
      subscription.subscription_configuration_status ===
        PopStoreSubscriptionStatus.Active
      ? (subscription.creator_subscription.current_price
          ?.price_without_precision ?? 0)
      : 0;
  };

  switch (level) {
    case PopStoreSubscriptionLevel.SUBSCRIBER: {
      const fanPrice = getPrice(PopStoreSubscriptionLevel.FAN);
      return fanPrice > 0 ? (fanPrice - 10) / 100 : undefined;
    }
    case PopStoreSubscriptionLevel.FAN: {
      const vipPrice = getPrice(PopStoreSubscriptionLevel.VIP);
      return vipPrice > 0 ? (vipPrice - 10) / 100 : undefined;
    }
    case PopStoreSubscriptionLevel.VIP:
      return undefined;
    default:
      return undefined;
  }
}
